export default __webpack_public_path__ + "static/media/clock.196fada1.svg";